import { render, staticRenderFns } from "./MetabaseContent.vue?vue&type=template&id=2ae45420&"
import script from "./MetabaseContent.vue?vue&type=script&lang=js&"
export * from "./MetabaseContent.vue?vue&type=script&lang=js&"
import style0 from "./MetabaseContent.vue?vue&type=style&index=0&id=2ae45420&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports